/**
 * apiFailure — ce qu'un échec de requête du moteur dit de la suivante.
 *
 * Une seule règle pour tout le moteur : le réseau, un serveur en panne ou une limite passent, la même
 * requête peut aboutir plus tard ; un refus (403, 404, 422…) se répète à l'identique. À part de
 * `apiCall` : les tests qui simulent `apiCall` (pour ne pas charger le magasin) gardent cette règle.
 */
import { ApiCallError } from "./apiCall"

/** Un échec qui vaut d'être retenté : le réseau, le serveur en panne, une limite. Un refus, non. */
export function isRetryableFailure(cause: unknown): boolean {
    if (!(cause instanceof ApiCallError)) return true
    const status = cause.status
    if (cause.failure?.isOffline || status == null || status === 0) return true
    return status >= 500 || status === 408 || status === 429
}
